@if (timeOut()) {
  <app-timeout></app-timeout>
}
@if (loading()) {
  <div class="h-full flex align-items-center justify-content-center m-4">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else {
  @if (form) {
    <div [formGroup]="form" class="modalForm denseGrid">
      <div class="flex flex-column gap-2 mb-3">
        <label for="articleNumber" class="font-semibold w-full"
          >{{ "gate_components.article_form.article_number" | translate }}*</label
        >
        <input pInputText id="articleNumber" formControlName="articleNumber" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="label" class="font-semibold w-full">{{ "gate_components.article_form.label" | translate }}*</label>
        <input pInputText id="label" formControlName="label" autocomplete="off" />
      </div>
      <div class="flex gap-2 mb-3 g-col-1-3">
        <label for="enableInspection">{{ "gate_components.article_form.enable_inspection" | translate }}</label>
        <p-checkbox formControlName="enableInspection" [binary]="true" inputId="enableInspection" />
      </div>
      @if (form.get("enableInspection")?.value) {
        <div class="flex gap-2 mb-3 g-col-1">
          <label for="enableInspectionLoadChanges">{{
            "gate_components.article_form.enable_load_changes" | translate
          }}</label>
          <p-checkbox
            formControlName="enableInspectionLoadChanges"
            [binary]="true"
            inputId="enableInspectionLoadChanges"
          />
        </div>
        @if (form.get("enableInspectionLoadChanges")?.value) {
          <div
            class="flex flex-column gap-2 mb-3 g-col-1"
            [ngClass]="{
              'g-col-1-3':
                !form.get('enableInspectionOperatingTime')?.value && form.get('enableInspectionLoadChanges')?.value,
            }"
          >
            <label for="loadChanges" class="font-semibold w-full"
              >{{ "gate_components.article_form.load_changes" | translate }}*</label
            >
            <p-inputNumber styleClass="w-full" id="loadChanges" formControlName="loadChanges" />
          </div>
        }
        <div class="flex gap-2 mb-3 g-col-2">
          <label for="enableInspectionOperatingTime">{{
            "gate_components.article_form.enable_operating_time" | translate
          }}</label>
          <p-checkbox
            formControlName="enableInspectionOperatingTime"
            [binary]="true"
            inputId="enableInspectionOperatingTime"
          />
        </div>
        @if (form.get("enableInspectionOperatingTime")?.value) {
          <div
            class="flex flex-column gap-2 mb-3 g-col-2"
            [ngClass]="{
              'g-col-1-3':
                form.get('enableInspectionOperatingTime')?.value && !form.get('enableInspectionLoadChanges')?.value,
            }"
          >
            <label for="operatingTime" class="font-semibold w-full"
              >{{ "gate_components.article_form.operating_time" | translate }}*</label
            >
            <p-inputNumber styleClass="w-full" id="operatingTime" formControlName="operatingTime" />
          </div>
        }
      }
      <div class="flex gap-2 mb-3 g-col-1-3">
        <label for="enableExchange">{{ "gate_components.article_form.enable_exchange" | translate }}</label>
        <p-checkbox formControlName="enableExchange" [binary]="true" inputId="enableExchange" />
      </div>
      @if (form.get("enableExchange")?.value) {
        <div class="flex gap-2 mb-3 g-col-1">
          <label for="enableExchangeLoadChanges">{{
            "gate_components.article_form.enable_load_changes" | translate
          }}</label>
          <p-checkbox formControlName="enableExchangeLoadChanges" [binary]="true" inputId="enableExchangeLoadChanges" />
        </div>
        @if (form.get("enableExchangeLoadChanges")?.value) {
          <div
            class="flex flex-column gap-2 mb-3 g-col-1"
            [ngClass]="{
              'g-col-1-3':
                !form.get('enableExchangeOperatingTime')?.value && form.get('enableExchangeLoadChanges')?.value,
            }"
          >
            <label for="maxLoadChanges" class="font-semibold w-full"
              >{{ "gate_components.article_form.max_load_changes" | translate }}*</label
            >
            <p-inputNumber styleClass="w-full" id="maxLoadChanges" formControlName="maxLoadChanges" />
          </div>
        }
        <div class="flex gap-2 mb-3 g-col-2">
          <label for="enableExchangeOperatingTime">{{
            "gate_components.article_form.enable_operating_time" | translate
          }}</label>
          <p-checkbox
            formControlName="enableExchangeOperatingTime"
            [binary]="true"
            inputId="enableExchangeOperatingTime"
          />
        </div>
        @if (form.get("enableExchangeOperatingTime")?.value) {
          <div
            class="flex flex-column gap-2 mb-3 g-col-2"
            [ngClass]="{
              'g-col-1-3':
                form.get('enableExchangeOperatingTime')?.value && !form.get('enableExchangeLoadChanges')?.value,
            }"
          >
            <label for="maxOperatingTime" class="font-semibold w-full"
              >{{ "gate_components.article_form.max_operating_time" | translate }}*</label
            >
            <p-inputNumber styleClass="w-full" id="maxOperatingTime" formControlName="maxOperatingTime" />
          </div>
        }
      }
      <div class="flex justify-content-end gap-2 dialogBtnGroup">
        <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
        <app-button
          buttonText="common.save"
          [disabled]="!form.valid || requestStarted()"
          (click)="save()"
          [loading]="requestStarted()"
        ></app-button>
      </div>
    </div>
  }
}
